const editStatuses = new Set([1, 12])
const actionStatuses = new Set([3, 4, 5, 13, 14, 15, 16, 37, 39])

export const getClaimAction = statusId => {
  const status = Number(statusId)
  if (editStatuses.has(status)) return 'edit'
  if (actionStatuses.has(status)) return 'action'
  return null
}
